import charming from "charming";
import anime from "animejs";

function getMousePos(ev) {
    let posx = 0;
    let posy = 0;
    if (!ev) ev = window.event;
    if (ev.pageX || ev.pageY) {
        posx = ev.pageX;
        posy = ev.pageY;
    } else if (ev.clientX || ev.clientY) {
        posx =
      ev.clientX +
      document.body.scrollLeft +
      document.documentElement.scrollLeft;
        posy =
      ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    return { x: posx, y: posy };
}

class Letter {
    constructor(letter) {
        this.config = {
            color: "#fff",
            trailDelay: 0,
            maxScaleX: 1,
            minScaleX: 0.8,
            maxScaleY: 1.6,
            minScaleY: 1,
            stretchTransition: "color .3s, transform .4s cubic-bezier(0.1,1,0.3,1)",
            reverseAnim: {
                duration: 1000,
                easing: "easeOutElastic",
                elasticity: 600,
                scaleY: 1,
                scaleX: 1
            }
        };
        this.letter = letter;
        this.layout();
        this.initEvents();
    }
    layout() {
        const { letter } = this;
        const letterInner = document.createElement("span");
        
        if (letter.innerHTML === ' ') letter.innerHTML = '&#160;'


        this.letterInner = letterInner;
        
        letterInner.innerHTML = letter.innerHTML;
        letterInner.style.display = "block";
        letterInner.style.color = "inherit !important";
        letter.style.color = "inherit !important";
        letter.innerHTML = "";
        letter.appendChild(letterInner);
    }
    stretch(ev) {
        const { config, letterInner, letter } = this;
        const { documentElement, body } = document;
        const mousepos = getMousePos(ev);
        const docScrolls = {
            left: body.scrollLeft + documentElement.scrollLeft,
            top: body.scrollTop + documentElement.scrollTop
        };
        const bounds = letter.getBoundingClientRect();
        const realmousepos = {
            x: mousepos.x - bounds.left - docScrolls.left,
            y: mousepos.y - bounds.top - docScrolls.top
        };

        anime.remove(letterInner);
        letterInner.style.transformOrigin = "50% 100%";

        const sX =
      ((config.maxScaleX - config.minScaleX) / bounds.height) * realmousepos.y +
      config.minScaleX;
        const sY =
      ((config.minScaleY - config.maxScaleY) / bounds.height) * realmousepos.y +
      config.maxScaleY;

        letterInner.style.transform = `scaleX(${sX}) scaleY(${sY})`;
    }
    initEvents() {
        const { letter } = this;

        this.mouseenterFn = () =>
            (this.mouseTimeout = setTimeout(() => {
                this.isActive = true;
                requestAnimationFrame(
                    () =>
                        (this.letterInner.style.transition = this.config.stretchTransition)
                );
            }, 10));

        this.mousemoveFn = ev => {
            if (!this.isActive) return;
            requestAnimationFrame(() => this.stretch(ev));
        };

        this.mouseleaveFn = () => {
            const { letterInner, config } = this;

            clearTimeout(this.mouseTimeout);

            if (!this.isActive) {
                return;
            }

            this.isActive = false;
            letterInner.style.transition = "color .3s";

            requestAnimationFrame(() => {
                anime.remove(letterInner);

                let animOpts = { targets: letterInner };

                anime(Object.assign(animOpts, config.reverseAnim));
            });
        };

        letter.addEventListener("mouseenter", this.mouseenterFn);
        letter.addEventListener("mousemove", this.mousemoveFn);
        letter.addEventListener("mouseleave", this.mouseleaveFn);
        letter.addEventListener("touchstart", this.mouseenterFn);
        letter.addEventListener("touchend", this.mouseleaveFn);
    }
}

class Word {
    constructor(word) {
        this.word = word;
        this.layout();
    }
    layout() {
        const { word } = this;

        charming(word, { classPrefix: "letter" });

        Array.from(word.querySelectorAll("span")).forEach(
            letter => new Letter(letter)
        );
    }
}

export default {
    inserted(el, binding) {
        const { value, modifiers } = binding;
        const { multiple } = modifiers;

        if (value) {
            if (multiple) {
                const elements = [...el.querySelectorAll(value)];

                elements.forEach(e => new Word(e));
            } else {
                new Word(el.querySelector(value)); // eslint-disable-line no-new
            }
        } else {
            new Word(el); // eslint-disable-line no-new
        }
    }
};



// WEBPACK FOOTER //
// ./src/directives/fancy-letters.directive.js